<template>
  <div>
    <div class="access-header">
      <h2>{{ $t("admin.adminWhitelistView.name") }}</h2>
      <button class="access-btn add-btn" @click="showAddModal = true">
        {{ $t("admin.adminWhitelistView.button.add") }}
      </button>
    </div>

    <div>
      <table class="datatable">
        <thead>
          <tr>
            <th scope="col">
              {{ $t("admin.adminWhitelistView.table.lastModified") }}
            </th>
            <th scope="col">{{ $t("admin.adminWhitelistView.table.ip") }}</th>
            <th scope="col">
              {{ $t("admin.adminWhitelistView.table.email") }}
            </th>
            <th scope="col">
              {{ $t("admin.adminWhitelistView.table.description") }}
            </th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody v-if="accessList.length > 0">
          <tr
            v-for="(access, index) in accessList"
            :key="index"
            v-bind:class="{ 'disabled-access': !access.enabled }"
          >
            <td>{{ new Date(access.updatedTimestamp).toLocaleString() }}</td>
            <td>{{ access.ip ? access.ip : "-" }}</td>
            <td id="email">
              {{ access.emailAddress ? access.emailAddress : "-" }}
            </td>
            <td id="description">{{ access.description }}</td>

            <td>
              <button
                class="access-btn edit-btn"
                @click="editAccess(access, index)"
              >
                {{ $t("admin.adminWhitelistView.button.edit") }}
              </button>
              <button
                class="access-btn toggle-btn"
                @click="toggleAccess(access, index, false)"
                v-if="access.enabled"
              >
                {{ $t("admin.adminWhitelistView.button.disable") }}
              </button>
              <button
                class="access-btn toggle-btn"
                @click="toggleAccess(access, index, true)"
                v-else
              >
                {{ $t("admin.adminWhitelistView.button.enable") }}
              </button>
              <button
                class="access-btn delete-btn"
                @click="deleteAccess(access)"
              >
                {{ $t("admin.adminWhitelistView.button.delete") }}
              </button>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="5" class="no-data">
              {{ $t("admin.adminWhitelistView.table.noData") }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <Modal
      v-if="showAddModal"
      v-bind:modalTitle="$t('admin.adminWhitelistAddForm.title')"
      @close="closeModal"
    >
      <AdminWhitelistAddForm
        v-bind="{
          planId: planId,
          fetchData: fetchData,
          checkExistingAccess: checkExistingAccess,
        }"
      />
    </Modal>
    <Modal
      v-if="showEditModal"
      v-bind:modalTitle="$t('admin.adminWhitelistEditForm.title')"
      @close="closeModal"
    >
      <AdminWhitelistEditForm
        v-bind="{
          planId: planId,
          currentAccess: currentAccess,
          selectedIndex: selectedIndex,
          fetchData: fetchData,
          checkExistingAccess: checkExistingAccess,
        }"
      />
    </Modal>
    <Modal
      class="alert"
      v-if="showDeleteModal"
      v-bind:modalTitle="
        $t('admin.adminWhitelistDelete.header', {
          value: currentAccess.value,
        })
      "
      @close="closeModal"
    >
      <AdminWhitelistDelete
        v-bind="{
          planId: planId,
          currentAccess: currentAccess,
          fetchData: fetchData,
        }"
      />
    </Modal>
  </div>
</template>
<script>
import Modal from "@/components/Modal.vue";
import AdminWhitelistAddForm from "./AdminWhitelistAddForm.vue";
import AdminWhitelistEditForm from "./AdminWhitelistEditForm.vue";
import AdminWhitelistDelete from "./AdminWhitelistDelete.vue";
import { adminService } from "../../services/admin.service";
export default {
  name: "AdminWhitelistView",
  props: ["planId"],
  components: {
    Modal,
    AdminWhitelistAddForm,
    AdminWhitelistEditForm,
    AdminWhitelistDelete,
  },
  data() {
    return {
      accessList: [],
      selectedIndex: -1,
      currentAccess: null,
      showEditModal: false,
      showAddModal: false,
      showDeleteModal: false,
    };
  },
  methods: {
    editAccess(access, index) {
      this.selectedIndex = index;
      this.currentAccess = {
        id: access.id,
        value: access.ip ? access.ip : access.emailAddress,
        type: access.ip ? 0 : 1,
        description: access.description,
        enabled: access.enabled,
      };
      this.showEditModal = true;
    },
    toggleAccess(access, index, enabled) {
      const body = {
        ip: access.ip,
        emailAddress: access.emailAddress,
        description: access.description,
        enabled,
      };
      adminService.whitelistUpdate(this.planId, access.id, body).then(() => {
        this.accessList[index].enabled = enabled;
      });
    },
    deleteAccess(access) {
      this.currentAccess = {
        id: access.id,
        value: access.ip ? access.ip : access.emailAddress,
        type: access.ip ? 0 : 1,
        description: access.description,
      };
      this.showDeleteModal = true;
    },
    closeModal() {
      this.showAddModal = false;
      this.showEditModal = false;
      this.showDeleteModal = false;
      this.currentAccess = null;
    },
    fetchData() {
      adminService.whitelistForPlan(this.planId).then((data) => {
        this.accessList = data;
        this.closeModal();
      });
    },
    checkExistingAccess(value, index) {
      return this.accessList.some(
        (access, ind) =>
          ind != index && (access.ip === value || access.emailAddress === value)
      );
    },
  },
  watch: {
    planId: function (newPlanId) {
      this.planId = newPlanId;
      this.fetchData();
    },
  },
};
</script>
<style scoped lang="scss">
.access-header {
  display: flex;
  justify-content: start;
  align-items: center;
  margin-bottom: 1rem;
  gap: 1rem;
}

.access-btn {
  background-color: #ddddff;
  padding: 0.1rem;
  border-radius: 5px;
  cursor: pointer;
  margin: 0;
  min-width: 4rem;
  font-size: 0.8rem;
  font-weight: 400;
  height: 2rem;
}

.add-btn {
  font-weight: 600;
  font-size: 1rem;
}

.edit-btn {
  border-radius: 5px 0px 0px 5px;
}

.toggle-btn {
  border-radius: 0px;
  border-left: none !important;
  border-right: none !important;
  margin: 0 1px;
}

.delete-btn {
  border-radius: 0px 5px 5px 0px;
  color: #ff0000;
}
.no-data {
  text-align: center;
  color: #999999;
  padding: 1rem 0 !important;
}
.disabled-access {
  color: #999999;
}
#email {
  max-width: 10rem;
  word-wrap: break-word;
}
#description {
  max-width: 10rem;
  word-wrap: break-word;
}
</style>
